import { useCallback, useEffect, useState } from 'react';
import { UseTabsProps, UseTabsReturn } from '../@types';

const useTabs = <T>({ defaultTab, tabConfig, onChange }: UseTabsProps<T>): UseTabsReturn<T> => {
  const [activeTab, setActiveTab] = useState<T>(defaultTab || tabConfig[0]?.value);

  useEffect(() => {
    setActiveTab(defaultTab || tabConfig[0]?.value);
  }, [defaultTab, tabConfig]);

  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, selectedTab: T) => {
      setActiveTab(selectedTab);
      onChange?.(selectedTab);
    },
    [onChange]
  );

  return {
    value: activeTab,
    setValue: setActiveTab,
    onChange: handleTabChange,
  };
};

export default useTabs;
